import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import VueViewer from 'v-viewer'

createApp(App).use(VueViewer).use(router).mount('#app')
